import React, { Component } from 'react';
import { func, string } from 'prop-types';

import Tooltip from '@material-ui/core/Tooltip';

import InteractiveIcon from '../../components/InteractiveIcon';

import classes from './FileUploadInput.module.css';

export default class FileUploadInput extends Component {
    state = {
        fileName: null
    }

    componentDidUpdate(prevProps) {
        const { fileName } = this.props;

        if (prevProps.fileName !== fileName) {
            this.setState({ fileName });
        }
    }

    handleUpload = ({ target }) => {
        const fileReader = new FileReader();

        fileReader.readAsDataURL(target.files[0]);
        fileReader.onload = e => {
            this.setState(() => ({
                fileName: target.files[0].name
            }));

            this.props.upload({
                file:     e.target.result,
                fileName: target.files[0].name
            });
        };
    };

    handleClearFile = () => {
        this.setState(() => ({
            fileName: null
        }));

        this.props.clear();
    }

    render() {
        let { accept, initialText = 'No file selected' } = this.props;
        return (
            <div className={classes.FileUploadInput}>
                <p className={classes.uploadFileName}>
                    <span>
                        {this.state.fileName ? this.state.fileName : initialText}
                    </span>
                    <InteractiveIcon
                        hidden={!this.state.fileName}
                        icon="fa-times"
                        iconSet="fas"
                        label="Clear selected file"
                        onClick={this.handleClearFile}
                    />
                    {!this.state.fileName &&
                    <label htmlFor="fileId">
                        <input
                            accept={accept}
                            onChange={this.handleUpload}
                            style={{ display: 'none' }}
                            id="fileId"
                            type="file"
                            key={this.state.fileName}
                        />
                        <Tooltip
                            placement="top-start"
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>{`${accept} files only`}</span>
                                </React.Fragment>
                            }
                        >
                            <img
                                className={classes.uploadIcon}
                                src="/assets/images/uploadIconBlue.svg" alt="upload icon"
                            />
                        </Tooltip>
                    </label>
                    }
                </p>
            </div>
        );
    }
}

FileUploadInput.propTypes = {
    accept:   string.isRequired,
    fileName: string,
    upload:   func.isRequired,
    clear:    func.isRequired
};
